import { createTheme } from '@mui/material/styles';

export const createAwqafTheme = (direction = 'ltr') => {
  return createTheme({
    direction: direction,
    palette: {
      primary: {
        main: "#e88b24", // Orange color
        light: "#ffb74d", // Light orange
        dark: "#d84315", // Darker orange
        contrastText: "#ffffff"
      },
      secondary: {
        main: "#66b1da", // Blue color
        light: "#90caf9", // Light blue
        dark: "#1976d2", // Dark blue
        contrastText: "#ffffff"
      },
      background: {
        default: "#f5f5f5", // Light gray background
        paper: "#ffffff",
      },
      text: {
        primary: "#e88b24",
        secondary: "#66b1da",
      },
      success: {
        main: "#66b1da",
        light: "#90caf9",
        dark: "#1976d2"
      },
      error: {
        main: "#d32f2f",
        light: "#ef5350",
        dark: "#c62828"
      },
      warning: {
        main: "#ed6c02",
        light: "#ff9800",
        dark: "#e65100"
      },
      info: {
        main: "#0288d1",
        light: "#03a9f4",
        dark: "#01579b"
      }
    },
    typography: {
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        'Oxygen',
        'Ubuntu',
        'Cantarell',
        '"Fira Sans"',
        '"Droid Sans"',
        '"Helvetica Neue"',
        'sans-serif',
        // Arabic fonts
        '"Droid Arabic Naskh"',
        '"Arabic Typesetting"',
        'Tahoma',
        'Arial'
      ].join(','),
      h1: {
        fontWeight: 700,
        fontSize: '2.5rem',
        lineHeight: 1.2,
        color: '#e88b24'
      },
      h2: {
        fontWeight: 600,
        fontSize: '2rem',
        lineHeight: 1.3,
        color: '#e88b24'
      },
      h3: {
        fontWeight: 600,
        fontSize: '1.75rem',
        lineHeight: 1.4,
        color: '#e88b24'
      },
      h4: {
        fontWeight: 500,
        fontSize: '1.5rem',
        lineHeight: 1.4,
        color: '#e88b24'
      },
      h5: {
        fontWeight: 500,
        fontSize: '1.25rem',
        lineHeight: 1.5,
        color: '#e88b24'
      },
      h6: {
        fontWeight: 500,
        fontSize: '1.125rem',
        lineHeight: 1.5,
        color: '#e88b24'
      },
      body1: {
        fontSize: '1rem',
        lineHeight: 1.6,
        color: '#66b1da'
      },
      body2: {
        fontSize: '0.875rem',
        lineHeight: 1.6,
        color: '#66b1da'
      }
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: '#f5f5f5',
            color: '#e88b24',
            boxShadow: 'none',
            borderBottom: '1px solid rgba(232, 139, 36, 0.12)'
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            textTransform: 'none',
            fontWeight: 500,
            padding: '8px 16px'
          },
          contained: {
            boxShadow: 'none',
            '&:hover': {
              boxShadow: '0 2px 8px rgba(232, 139, 36, 0.24)'
            }
          },
          outlined: {
            borderWidth: '2px',
            '&:hover': {
              borderWidth: '2px'
            }
          }
        }
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            boxShadow: '0 2px 12px rgba(232, 139, 36, 0.08)',
            border: '1px solid rgba(232, 139, 36, 0.08)'
          }
        }
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            fontWeight: 500
          }
        }
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              borderRadius: 8,
              '&.Mui-focused fieldset': {
                borderColor: '#e88b24',
                borderWidth: 2
              }
            }
          }
        }
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            backgroundImage: 'none'
          }
        }
      },
      MuiToolbar: {
        styleOverrides: {
          root: {
            minHeight: '64px !important',
            padding: '0 24px'
          }
        }
      },
      MuiTab: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '1rem',
            minHeight: 48,
            '&.Mui-selected': {
              color: '#e88b24',
              fontWeight: 600
            }
          }
        }
      },
      MuiTabs: {
        styleOverrides: {
          indicator: {
            backgroundColor: '#e88b24',
            height: 3,
            borderRadius: '3px 3px 0 0'
          }
        }
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            color: '#e88b24',
            '&:hover': {
              backgroundColor: 'rgba(232, 139, 36, 0.04)'
            }
          }
        }
      },
      MuiLinearProgress: {
        styleOverrides: {
          root: {
            borderRadius: 4,
            backgroundColor: 'rgba(232, 139, 36, 0.12)'
          },
          bar: {
            borderRadius: 4
          }
        }
      },
      MuiAlert: {
        styleOverrides: {
          root: {
            borderRadius: 8
          }
        }
      }
    },
    shape: {
      borderRadius: 8
    },
    spacing: 8
  });
};

export default createAwqafTheme;